export const FrequencyType: any = {
  0: "Frequency",
  2: "Weekly",
  3: "Monthly",
  6: "Yearly"
}
